import { EllipsedText, MaterialIcon, useMoment } from '@gorila-shared-ui/components';
import { StyledLink } from 'baseui/link';
import { StyledCell, StyledRow } from 'baseui/table';
import { CSSProperties, memo } from 'react';
import { areEqual, ListChildComponentProps } from 'react-window';
import {
  ADDRESS_COLUMN_SIZE,
  DATE_COLUMN_MAX_WIDTH,
  DATE_COLUMN_SIZE,
  SPEED_COLUMN_MAX_WIDTH,
  SPEED_COLUMN_SIZE,
  STATUS_COLUMN_MAX_WIDTH,
  STATUS_COLUMN_SIZE,
} from '../../constants/tracking';
import { useStyles } from '../../hooks/useStyles';
import { HistoricState } from '../../types/currentState';
import { StyledTooltip } from '../ui/StyledTooltip';

function TrackingRow({ data, index, style }: Readonly<ListChildComponentProps<HistoricState[]>>) {
  const state = data[index];
  const { theme } = useStyles();
  const { formatDateFromTs } = useMoment();

  return (
    <StyledRow
      key={index}
      style={style as CSSProperties}
    >
      <StyledCell style={{ flex: DATE_COLUMN_SIZE, maxWidth: DATE_COLUMN_MAX_WIDTH }}>
        {formatDateFromTs(+state.timestamp)}
      </StyledCell>
      <StyledCell style={{ flex: STATUS_COLUMN_SIZE, maxWidth: STATUS_COLUMN_MAX_WIDTH, justifyContent: 'center' }}>
        <StyledTooltip
          content={state.engine_ignition_status ? 'Encendido' : 'Apagado'}
          showArrow={false}
        >
          <MaterialIcon
            name="power_settings_new"
            color={state.engine_ignition_status ? theme.colors.contentPositive : theme.colors.contentNegative}
          />
        </StyledTooltip>
      </StyledCell>
      <StyledCell style={{ flex: SPEED_COLUMN_SIZE, maxWidth: SPEED_COLUMN_MAX_WIDTH, justifyContent: 'center' }}>
        {state.position_speed} Km/h
      </StyledCell>
      <StyledCell style={{ flex: ADDRESS_COLUMN_SIZE }}>
        <StyledLink
          href={`https://maps.google.com/?q=${state.position_latitude},${state.position_longitude}`}
          target="_blank"
          style={{ ...theme.typography.ParagraphSmall }}
        >
          <EllipsedText
            inline
            breakAll
          >
            {state.geoReference}
          </EllipsedText>
        </StyledLink>
      </StyledCell>
    </StyledRow>
  );
}

export default memo(TrackingRow, areEqual);
